module.exports = __webpack_public_path__ + "img/weddings_02_H.3974eb4f.jpg";